export const CONTACT = {
  address: "Level 4, 490 Northbourne Ave",
  suburb: "Dickson ACT 2602",
  email: "info@catalysts.au",
  phoneDisplay: "0466 661 576",
  phoneHref: "tel:+61466661576",
  hours: "Mon–Fri, 8:30am–5:30pm",
  mapSrc: "https://maps.google.com/maps?q=Level%204%2C%20490%20Northbourne%20Ave%2C%20Dickson%20ACT%202602&t=&z=16&ie=UTF8&iwloc=&output=embed",
};

export const NAV = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/work", label: "Work" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  {
    slug: "marketing-strategy",
    title: "Marketing strategy",
    form: "Marketing strategy",
    icon: "Compass",
    short: "A plan you'll actually use. Where to focus, what to spend, and how you'll know it's working.",
    intro: "Before we spend a dollar of yours, we get to know your business, your customers and your competition. Then we build a plan that fits on a page and gets used, not filed.",
    includes: ["Customer and competitor research", "Positioning and key messages", "Channel and budget plan", "90-day action roadmap", "Simple reporting dashboard"],
    outcome: "Clarity. And a to-do list that pays for itself.",
  },
  {
    slug: "content-creation",
    title: "Content creation",
    form: "Content creation",
    icon: "PenLine",
    short: "Words, photos and video that sound like you on a very good day.",
    intro: "Good content answers real questions and quietly earns trust. We plan it, write it and shoot it, so you can get back to running the place.",
    includes: ["Content plan and calendar", "Website and blog copy", "Photo and short-form video shoots", "Case studies and guides", "Repurposing across channels"],
    outcome: "Content people actually finish.",
  },
  {
    slug: "seo",
    title: "SEO",
    form: "SEO",
    icon: "Search",
    short: "Be the answer when Canberra goes looking for what you do.",
    intro: "We make your site easy for search engines to understand and easy for people to choose, with a big focus on local search. No dark arts. Just the work.",
    includes: ["Website health check and fixes", "Keyword and local search research", "Google Business Profile optimisation", "On-page improvements", "Monthly ranking and lead reports"],
    outcome: "Found first. Chosen more often.",
  },
  {
    slug: "social-media",
    title: "Social media",
    form: "Social media",
    icon: "MessageCircle",
    short: "Show up consistently, sound like yourself, and give people a reason to stop scrolling.",
    intro: "We help you turn up in the right places with posts worth seeing. Planning, creating, posting, replying and reporting: handled.",
    includes: ["Channel strategy", "Monthly content calendar", "Post design and copywriting", "Community management", "Performance reporting"],
    outcome: "An audience that knows you, likes you and remembers you.",
  },
  {
    slug: "email-marketing",
    title: "Email marketing",
    form: "Email marketing",
    icon: "Mail",
    short: "Emails people open on purpose. From welcome series to newsletters worth reading.",
    intro: "Email is still one of the best-value channels around, and one of the most neglected. We send the right message to the right person at the right moment.",
    includes: ["Platform setup and list clean-up", "Welcome and follow-up sequences", "Newsletter design and writing", "Segmentation", "Open, click and sales tracking"],
    outcome: "More repeat customers. Less chasing.",
  },
  {
    slug: "paid-advertising",
    title: "Paid advertising",
    form: "Paid advertising",
    icon: "Target",
    short: "Google, Meta and LinkedIn campaigns built to bring in leads, not just clicks and compliments.",
    intro: "We plan, build and manage campaigns with clear goals and honest reporting. Every dollar gets a job description.",
    includes: ["Campaign strategy and setup", "Ad creative and copy", "Landing page recommendations", "Ongoing testing and optimisation", "Clear monthly reporting"],
    outcome: "Predictable leads at a cost that makes sense.",
  },
];

export const SERVICE_OPTIONS = [...SERVICES.map((s) => s.form), "Not sure yet"];

export const CASES = [
  {
    slug: "solar-installer-lead-growth",
    client: "[Client name] Solar",
    industry: "Renewable energy",
    image: "/img/case1.webp",
    challenge: "Rising ad costs and a quiet phone in a crowded local market.",
    approach: "Local SEO, a simpler quote page and tightly focused Google Search campaigns.",
    results: "More than triple the qualified quote requests in three months, at a lower cost per lead.",
    metrics: [["+3.4x", "quote requests"], ["−42%", "cost per lead"], ["90", "days"]],
    services: ["SEO", "Paid advertising"],
  },
  {
    slug: "allied-health-clinic-bookings",
    client: "[Client name] Health",
    industry: "Allied health",
    image: "/img/case2.webp",
    challenge: "Two clinics that were hard to find online, with bookings flat for a year.",
    approach: "Google Business Profile clean-up, helpful patient content and simple Meta booking ads.",
    results: "Top-three local rankings for key searches and a big lift in online bookings.",
    metrics: [["Top 3", "local results"], ["+2.1x", "online bookings"], ["4.9★", "average review"]],
    services: ["SEO", "Content creation", "Social media"],
  },
  {
    slug: "craft-brewery-brand-refresh",
    client: "[Client name] Brewing Co.",
    industry: "Food & beverage",
    image: "/img/case3.webp",
    challenge: "A great product with a brand story that wasn't landing with venues or drinkers.",
    approach: "A sharper brand story, candid content shoots and an automated email program for stockists.",
    results: "New stockists across the region and strong growth in online sales.",
    metrics: [["+60", "new stockists"], ["+80%", "online sales"], ["48%", "email open rate"]],
    services: ["Marketing strategy", "Content creation", "Email marketing"],
  },
  {
    slug: "b2b-tech-pipeline",
    client: "[Client name] Technologies",
    industry: "B2B technology",
    image: "/img/case4.webp",
    challenge: "Long sales cycles and very few conversations with real decision makers.",
    approach: "A focused account-based plan with LinkedIn ads, useful guides and follow-up emails.",
    results: "More meetings with the right people and a noticeably shorter sales cycle.",
    metrics: [["+2.6x", "sales meetings"], ["−35%", "sales cycle"], ["6", "months"]],
    services: ["Marketing strategy", "Paid advertising", "Email marketing"],
  },
];

export const TEAM = [
  { name: "Mohit", role: "Director", image: "/img/mohit.webp" },
];

export const VALUES = [
  { title: "Results over theatre", text: "Pretty reports are nice. Revenue is nicer. We agree on what success looks like before we start, then report on exactly that." },
  { title: "Plain talking", text: "If we can't explain it simply, we shouldn't be charging for it. No jargon, no smoke, no mirrors." },
  { title: "Local, properly", text: "We live and work in Canberra. We know the market, the suburbs, and that Braddon and Belconnen are not the same audience." },
  { title: "Never set-and-forget", text: "We test, learn and tweak every month. Marketing that stands still quietly goes backwards." },
];

export const TESTIMONIALS = [
  { quote: "A few months in, the phone started ringing again. Turns out that's what marketing is supposed to do.", name: "[Client name]", role: "Owner, [Business name]" },
  { quote: "They asked better questions about our business than we'd ever asked ourselves. The plan just made sense.", name: "[Client name]", role: "Director, [Business name]" },
  { quote: "Clear reports, fresh ideas, zero fluff. Like having an in-house team, minus the extra desks.", name: "[Client name]", role: "Marketing Manager, [Business name]" },
];

export const STATS = [
  ["[120+]", "local businesses helped"],
  ["[3.1x]", "average lift in leads"],
  ["[10]", "years in Canberra"],
];
